import type { FormName, ModalName } from '@coursera/event-pulse-types';

import {
  AUTHENTICATION_FORM_VARIANTS,
  type AUTHENTICATION_FORM_VARIANTS_KEY,
  AUTHENTICATION_MODAL_MODES,
  type AUTHENTICATION_MODAL_MODES_KEY,
} from 'bundles/authentication-common/constants';

const getLoginFormName = (
  formVariant?: AUTHENTICATION_FORM_VARIANTS_KEY,
  socialSsoService?: 'google' | 'facebook' | 'apple'
): FormName | undefined => {
  switch (formVariant) {
    case AUTHENTICATION_FORM_VARIANTS.PASSWORD:
      return 'login_with_email';
    case AUTHENTICATION_FORM_VARIANTS.SOCIALSSO:
      switch (socialSsoService) {
        case 'google':
          return 'login_with_google';
        case 'facebook':
          return 'login_with_facebook';
        case 'apple':
          return 'login_with_apple';
        default:
          return undefined;
      }
    default:
      return undefined;
  }
};

const getModalTrackerValue = ({
  mode,
  isProgressiveAuth,
  formVariant,
  socialSsoService,
}: {
  mode: AUTHENTICATION_MODAL_MODES_KEY;
  isProgressiveAuth: boolean;
  formVariant?: AUTHENTICATION_FORM_VARIANTS_KEY;
  socialSsoService?: 'google' | 'facebook' | 'apple';
}): { modalName: ModalName; formName?: FormName } | undefined => {
  switch (mode) {
    case AUTHENTICATION_MODAL_MODES.LOGIN:
    case AUTHENTICATION_MODAL_MODES.SIGNUP:
      if (isProgressiveAuth) {
        return { modalName: 'unified_authentication' };
      }
      return { modalName: mode };
    case AUTHENTICATION_MODAL_MODES.SIGNUPCONTINUE:
      return { modalName: 'signup', formName: 'signup_with_email' };
    case AUTHENTICATION_MODAL_MODES.LOGINCONTINUE:
      return { modalName: 'login', formName: getLoginFormName(formVariant, socialSsoService) };
    case AUTHENTICATION_MODAL_MODES.ORGANIZATIONLOGIN:
      return { modalName: 'login_with_organization' };
    case AUTHENTICATION_MODAL_MODES.ORGANIZATIONSIGNUP:
      return { modalName: 'signup_with_organization' };
    case AUTHENTICATION_MODAL_MODES.FORGOT:
      return { modalName: 'forgot_password' };
    case AUTHENTICATION_MODAL_MODES.MAGICLINK:
      return { modalName: 'magic_link_sent' };
    default:
      return undefined;
  }
};

export { getModalTrackerValue };
